import { Services } from '@sigma-frontend-libs/commons'

import { getSocket, globalErrorHandler, proxy, request } from '@/utils'

import render from './render'

export default {
  name: 'Dialog',

  mixins: [ proxy() ],

  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      sendings: [],

      loading: false,

      pagination: {
        limit: 10,
        offset: 0,
        total: 0
      }
    }
  },

  watch: {
    'pagination.offset'() {
      this.getSendings()
    }
  },

  mounted() {
    this.getSendings()

    const socket = getSocket()
    socket?.on(`${Services.sendingsModeration}.sendings.created`, data => {
      if (data.taskId === this.data.id) {
        const index = this.sendings.findIndex(sending => {
          return sending.sendingId === data.sendingId
        })
        if (!~index) {
          this.sendings.unshift(data)
        }
      }
    })
  },

  methods: {
    async getSendings() {
      if (this.checkPermissions(`advanced.${Services.sendingsModeration}.get`)) {
        try {
          this.loading = true
          const path = [ Services.sendingsModeration, this.data.id, Services.sendings ].join('/')
          const { data, total } = await request.find(path, undefined, {
            $offset: this.pagination.offset,
            $limit: this.pagination.limit
          })
          if (data) {
            this.sendings = data
            this.pagination.total = total
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    },

    copyId(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.addSnackbar({
          text: this.getTranslate('misc.copied'),
          type: 'success'
        })
      })
    }
  },

  render
}
